/**
 * Default mailbox for UI scope: among connected mailboxes, prefer the one
 * marked primary; otherwise the earliest created (stable when the API lists
 * newest-first). Returns null if none connected.
 */
export function defaultMailbox(mailboxes) {
  if (!mailboxes?.length) {
    return null;
  }
  const connected = mailboxes.filter((m) => m.connected);
  if (!connected.length) {
    return null;
  }
  const primary = connected.find((m) => m.is_primary);
  if (primary) {
    return primary;
  }
  const sorted = [...connected].sort((a, b) => {
    const ta = a.created_at || "";
    const tb = b.created_at || "";
    if (ta !== tb) {
      return ta.localeCompare(tb);
    }
    return (a.hash || "").localeCompare(b.hash || "");
  });
  return sorted[0] || null;
}

/** Active mailbox for the current scope hash, or the default / first row as last resort. */
export function resolveScopedMailbox(mailboxes, mailboxHash) {
  if (!mailboxes?.length) {
    return null;
  }
  if (mailboxHash) {
    const found = mailboxes.find((m) => m.hash === mailboxHash);
    if (found) {
      return found;
    }
  }
  return defaultMailbox(mailboxes) ?? mailboxes[0] ?? null;
}
